// motionVariants.js

export const navbarVariant = {
    initial: { y: -50, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    transition: { duration: 0.5, ease: 'easeOut' }
};

export const fadeUpVariant = (delay = 0.2, y = 40) => ({
    initial: { y, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    transition: { duration: 0.4, delay, ease: 'easeOut' }
});

export const heroImageVariant = {
    initial: { y: 50, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    transition: { duration: 0.6, delay: 0.5, ease: 'easeOut' }
};

export const cardFromLeft = (delay = 0.1, rotate = -10) => ({
    initial: { x: -100, rotate, opacity: 0 },
    animate: { x: 0, rotate: -rotate, opacity: 1 },
    transition: { duration: 0.4, delay, ease: 'easeOut' }
});

export const cardFromRight = (delay = 0.1, rotate = 10) => ({
    initial: { x: 100, rotate, opacity: 0 },
    animate: { x: 0, rotate: -rotate, opacity: 1 },
    transition: { duration: 0.4, delay, ease: 'easeOut' }
});

export const gradientFadeScale = (delay = 0.2) => ({
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.6, delay, ease: 'easeOut' }
})

export const lightFromCorner = (side = 'left', delay = 0.2) => {
    const translate = side === 'left'
        ? { x: -100, y: -100 }
        : { x: 100, y: -100 }

    return {
        initial: { ...translate, opacity: 0 },
        animate: { x: 0, y: 0, opacity: 1 },
        transition: { duration: 0.3, delay, ease: 'easeOut' }
    }
}

export const fadeUpOnView = (delay = 0, y = 40) => ({
    hidden: { opacity: 0, y },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            delay,
            duration: 0.5,
            ease: 'easeOut'
        }
    }
});

export const staggerContainer = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.3
        }
    }
};


// utils/motionVariants.js
export const spring = {
    type: 'spring',
    stiffness: 90,  // how “hard” the spring pulls back
    damping: 16,    // how much rebound/bounce you get
    mass: 0.7,      // lower = snappier
};

export const stagger = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.2,
        },
    },
};

/** Generic fade-up that accepts a delay (seconds) */
export const fadeUp = (delay = 0) => ({
    hidden: { opacity: 0, y: 32 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { ...spring, delay },
    },
});

